import * as React from 'react';
import { connect } from 'react-redux';
import IToastBar from './IToastBar';
import { actionCreators } from '../sidebar-bookmarks/redux/actions';
class ToastBar extends React.Component<IToastBar, null> {
    constructor(props) {
        super(props);
        
    }
    render() {
        const { toastBarType, toastBarMessage, displayToastBar, reset } = this.props;
        let cssType = '';
        switch (toastBarType) {
            case 'warn':
                cssType = 'toastbar--warn';
                break;
            case 'success':
                cssType = 'toastbar--success';
                break;
            default:
                break;
        }
        if (displayToastBar) {
            setTimeout(() => {
                reset();
            }, 3000);
        }
        return (
            <div>
                {
                    displayToastBar
                    ? <div className={`toastbar ${cssType}`}>{toastBarMessage}</div>
                    : null
                }
            </div>
        )
    }
}

const mapStateToProps = (state: IToastBar): IToastBar => {
    return { displayToastBar: state.displayToastBar, toastBarMessage: state.toastBarMessage, toastBarType: state.toastBarType };
}

const mapDispatchToProps = (dispatch) => {
    return {
        reset: () => {
            dispatch(actionCreators.toggleToastBar());
            dispatch(actionCreators.setToastBarType('info'));
            dispatch(actionCreators.setToastBarMessage(''));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ToastBar);